import {
  StyledOnboardingBody,
  StyledOnboardingHeader,
} from '@components/onboarding/styles';
import HeaderImage from '@assets/images/onboarding/step-4.png';
import { Typography } from '@mui/material';
import Spacer from '@components/layout-util-components/spacer';
import { OutlinedButton } from '@components/buttons';
import { StepProps } from '@components/onboarding/app-onboarding-modal';
import { Gap } from '@components/layout-util-components/gap';
const OnboardingStep4 = '/svgs/onboarding_step4.svg';

export function StepFourHeader() {
  return (
    <StyledOnboardingHeader
      className="step4"
      sx={({ palette }) => ({
        background: `url(${OnboardingStep4}) no-repeat center center ${palette.blue.dark}`,
      })}
    >
      <img src={HeaderImage} alt="step four header" />
    </StyledOnboardingHeader>
  );
}

export function StepFourBody({ onNext }: StepProps) {
  return (
    <StyledOnboardingBody>
      <div className="content">
        <Gap size={32} />
        <Typography variant="h2">Start problem solving today</Typography>
        <Gap size={15} />
        <Typography variant="body2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
          consectetur nisi sit amet risus luctus, at ornare odio aliquet.
          Integer orci ante, porttitor eu ipsum sed, finibus ultricies odio.
        </Typography>
        <Gap size={32} />
        <Spacer />
      </div>
      <div className="actions">
        <OutlinedButton onClick={onNext}>Get started</OutlinedButton>
      </div>
    </StyledOnboardingBody>
  );
}
